import { render, staticRenderFns } from "./FlexibleDetail.vue?vue&type=template&id=c9edd6ba&scoped=true"
import script from "./FlexibleDetail.vue?vue&type=script&lang=js"
export * from "./FlexibleDetail.vue?vue&type=script&lang=js"
import style0 from "./FlexibleDetail.vue?vue&type=style&index=0&id=c9edd6ba&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./FlexibleDetail.vue?vue&type=style&index=1&id=c9edd6ba&prod&lang=scss"
import style2 from "./FlexibleDetail.vue?vue&type=style&index=2&id=c9edd6ba&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9edd6ba",
  null
  
)

export default component.exports